import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import type { CandidateModuleStore } from 'candidate/core/candidate-module.store';

import { CandidateSidebarSectionView } from './candidate-sidebar-section';
import './candidate-sidebar.scss';

type CandidateSidebarProps = {
   store: CandidateModuleStore;
};

const CandidateSidebarView = ({ store }: CandidateSidebarProps) => {
   const { t } = useTranslation('global');

   return (
      <div className="candidate-sidebar-refactor">
         {store.sidebarSections.map((section) => (
            <CandidateSidebarSectionView
               key={section.id}
               section={section}
               onActionClick={store.handleSidebarAction}
               t={t}
            />
         ))}
      </div>
   );
};

const CandidateSidebar = observer(CandidateSidebarView);

export default CandidateSidebar;
